var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVotingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3349 9.74658L17.4177 12.6638L15.6665 10.9126",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4981 17.2497H22.5019",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49561 21.0013V7.49563C7.49561 5.83809 8.83931 4.49438 10.4969 4.49438H25.5031C27.1606 4.49438 28.5044 5.83809 28.5044 7.49563V21.0013",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49438 28.5045V23.2523C4.49438 22.0091 5.50216 21.0013 6.74532 21.0013H9.565C10.1616 21.0015 10.7337 21.2384 11.1557 21.6601L12.6203 23.1247C13.1829 23.6867 13.9455 24.0024 14.7407 24.0026H21.2579C22.0543 24.0028 22.8182 23.6865 23.3813 23.1232L24.6253 21.8792C25.1879 21.3172 25.9505 21.0015 26.7457 21.0013H29.2547C30.4979 21.0013 31.5056 22.0091 31.5056 23.2523V28.5045C31.5056 30.162 30.1619 31.5057 28.5044 31.5057H7.49563C5.83809 31.5057 4.49438 30.162 4.49438 28.5045Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVotingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/VotingIcon.93be68f2.svg";
export { ForwardRef as ReactComponent };